import React from "react"
import Navbar from "../../../../Common/Components/Navbar"
import Footer from "../../../../Common/Components/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import AdmissionDashboardComp  from "./Component/AdmissionDashboardComp"

const AdmissionDashboard =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AdmissionDashboardComp />
        </div>
        <Footer />
        </>
    )
}

export default AdmissionDashboard